import { ComponentDirective } from './../../../../directives/component.directive';
import { IConfig } from './../../../../interfaces/config.interface';
import {
  Component,
  OnInit,
  Inject,
  ViewChild,
  ComponentFactoryResolver,
} from '@angular/core';
import { StepComponent } from '../stepcomponent.class';
import { NextComponentService } from '../../../../../lib/services/next-component.service';
import { ComponentName } from '../../../../../lib/enum/component-name.enum';
import { PersonalInfoComponent } from '../personal-info/personal-info.component';
import { DisableComponentService } from '../../../../../lib/services/disable-component.service';
import { PreviousComponentService } from '../../../../../lib/services/previous-component.service';
import { StepType } from '../../../../enum/step-type.enum';
import { ResidenceInfoComponent } from '../residence-info/residence-info.component';
import { PreviousResidenceInfoComponent } from '../previous-residence-info/previous-residence-info.component';
import { EmploymentInfoComponent } from '../employment-info/employment-info.component';
import { PreviousEmploymentInfoComponent } from '../previous-employment-info/previous-employment-info.component';
import { AdditionalInfoComponent } from '../additional-info/additional-info.component';
import { ReviewInfoComponent } from '../review-info/review-info.component';
import { ComponentGroup } from '../../../../../lib/enum/component-group.enum';
import { CreditAppService } from '../../../../../lib/services/credit-app.service';
import { NotificationsService } from '../../../../../lib/services/notifications.service';
import {
  INotification,
  NotificationType,
} from '../../../../../lib/interfaces/notification.interface';
import { ConfirmationPageComponent } from '../confirmation-page/confirmation-page.component';
import { AnalyticsEventService } from '../../../../../lib/services/analytics-event.service';
import { ComponentLoaded } from '../../../../../lib/actions/analytics.action';
import { showCTA, hideCTA } from '../../../../utils/utils.functions';
import { PrequalComponent } from '../prequal/prequal/prequal.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'dt-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss'],
  standalone: false
})
export class StepperComponent implements OnInit {
  @ViewChild(ComponentDirective, { static: true })
  componentHost: ComponentDirective;
  activeIndex = 0;
  confirmation = true;
  stepnotSaved = false;
  jackedData: any;
  isUnlocked = false;
  isComponentHostInitialized = false;
  isBuyNow = false;
  hasbackButton = true;
  isLeadRoutingFlag:boolean = false;
  components: StepComponent[] = [
    new StepComponent(
      PersonalInfoComponent,
      ComponentName.PersonalInfoComponent,
      ComponentGroup.PersonalInfo,
      true
    ),
    new StepComponent(
      ResidenceInfoComponent,
      ComponentName.ResidenceInfoComponent,
      ComponentGroup.ResidenceInfo,
      true
    ),
    new StepComponent(
      PreviousResidenceInfoComponent,
      ComponentName.PreviousResidenceInfoComponent,
      ComponentGroup.ResidenceInfo,
      false
    ),
    new StepComponent(
      EmploymentInfoComponent,
      ComponentName.EmploymentInfoComponent,
      ComponentGroup.EmploymentInfo,
      true
    ),
    new StepComponent(
      PreviousEmploymentInfoComponent,
      ComponentName.PreviousEmploymentInfoComponent,
      ComponentGroup.EmploymentInfo,
      true
    ),
    new StepComponent(
      AdditionalInfoComponent,
      ComponentName.AdditionalInfoComponent,
      ComponentGroup.AdditionalInfo,
      true
    ),
    new StepComponent(
      PersonalInfoComponent,
      ComponentName.CoBuyerPersonalInfoComponent,
      ComponentGroup.CoBuyerPersonal,
      false,
      StepType.CoBuyer
    ),
    new StepComponent(
      ResidenceInfoComponent,
      ComponentName.CoBuyerResidenceInfoComponent,
      ComponentGroup.CoBuyerResidence,
      false,
      StepType.CoBuyer
    ),
    new StepComponent(
      PreviousResidenceInfoComponent,
      ComponentName.CoBuyerPreviousResidenceInfoComponent,
      ComponentGroup.CoBuyerResidence,
      false,
      StepType.CoBuyer
    ),
    new StepComponent(
      EmploymentInfoComponent,
      ComponentName.CoBuyerEmploymentInfoComponent,
      ComponentGroup.CoBuyerEmployment,
      false,
      StepType.CoBuyer
    ),
    new StepComponent(
      PreviousEmploymentInfoComponent,
      ComponentName.CoBuyerPreviousEmploymentInfoComponent,
      ComponentGroup.CoBuyerEmployment,
      false,
      StepType.CoBuyer
    ),
    new StepComponent(
      AdditionalInfoComponent,
      ComponentName.CoBuyerAdditionalInfoComponent,
      ComponentGroup.CoBuyerAdditional,
      false,
      StepType.CoBuyer
    ),
    new StepComponent(
      ReviewInfoComponent,
      ComponentName.ReviewInfoComponent,
      ComponentGroup.ReviewInfo,
      true,
      StepType.General
    ),
    new StepComponent(
      ConfirmationPageComponent,
      ComponentName.ConfirmationPageComponent,
      ComponentGroup.ConfirmationPage,
      true,
      StepType.General
    ),
  ];
  flagForBuyNowConfirmation: boolean;
  isLegacyCreditApp:boolean = false;
  constructor(
    @Inject('config') public config: IConfig,
    private componentFactoryResolver: ComponentFactoryResolver,
    private nextComponentService: NextComponentService,
    private disableComponentService: DisableComponentService,
    private previousComponentService: PreviousComponentService,
    private creditAppService: CreditAppService,
    private notificationService: NotificationsService,
    private analyticsEventService: AnalyticsEventService
  ) { }

  ngOnInit() {

    if (this.config.Sitecore) {
      this.isBuyNow = this.config.Sitecore.isBuyNow;
      if (this.config.Sitecore.CreditApplicationConfig) {
        this.jackedData = this.config.Sitecore.CreditApplicationConfig;
        this.isLegacyCreditApp = this.config.Sitecore.isLegacyCreditApp;
      }
    }
  if(this.config.Sitecore.isLegacyCreditApp){
    this.components.splice(0, 0, new StepComponent(
      PrequalComponent,
      ComponentName.PreQualComponent,
      ComponentGroup.PrequalLegacyCA,
      true
    ));
  }

    if (this.isUnlocked && !this.isComponentHostInitialized) {
      this.isComponentHostInitialized = true;
      this.initializeComponentHost();
    }
    this.nextComponentService.nextComponentToBeLoaded$.subscribe(
      (componentDetails) => {
        if (componentDetails !== null) {
          this.loadComponent(componentDetails.component);
        }
      }
    );

    this.disableComponentService.componentToBeDisabled$.subscribe(
      (componentDetails) => {
        if (componentDetails !== null) {
          this.disableComponent(componentDetails.component);
        }
      }
    );

    this.previousComponentService.previousComponentToBeLoaded$.subscribe(
      (currentComponentDetails) => {
        if (currentComponentDetails !== null) {
          this.loadPreviousComponent(currentComponentDetails.component);
        }
      }
    );

    this.notificationService.notificationBroadcasted$.subscribe(
      (n: INotification) => {
        if (n !== null && n.Type === NotificationType.coBuyerDeactivation) {
          this.deActivateCoBuyerFlow();
        } else if (n !== null && n.Type === NotificationType.confirmation) {
          this.confirmation = false;
        } else if (n !== null && n.Type === NotificationType.startingNewCreditApp) {
          this.confirmation = true;
        }
        if (n !== null && n.Type === NotificationType.error) {
          this.stepnotSaved = true;
          if(n.Message === 'Could not determine the store to use'){
            this.isLeadRoutingFlag = true;
            this.jackedData.JackedCTA = this.jackedData.LeadRouteJackedCTA;
          }
          if(this.isLegacyCreditApp){
            const headerMain = document.getElementsByClassName('legacy-credit-next-cta') as HTMLCollectionOf<HTMLElement>;
            /* istanbul ignore next */
          if (headerMain.length > 0) {
            headerMain[0].style.visibility ='hidden';
          }
          }
          const root = document.body.getElementsByClassName('main-body')[0];
          root.classList.add('creditapp-body-jacked');
          hideCTA();
        }
      }
    );
  }
  /* istanbul ignore next */
  initializeComponentHost() {
    // if creditapp completed just load last step
    if (this.creditAppService.CreditApplication.creditApplicationCompleted) {
      this.activeIndex = 13;
      if (this.isBuyNow) {
        this.flagForBuyNowConfirmation = true;
        try {
          /* istanbul ignore next */
          if ((window as any).buynow) {
            (window as any).buynow.navigation.hidePrev();
            (window as any).buynow.navigation.hideNext();
          }
        } catch (e) {
          console.log(e);
        }
      }
      this.loadComponent(this.components[this.activeIndex]);
      return;
    }

    if (this.creditAppService.CreditApplication.step >= 1) {
      this.activeIndex = this.creditAppService.CreditApplication.step;
      if (
        !this.creditAppService.CreditApplication.coBuyer &&
        this.creditAppService.CreditApplication.step === 6
      ) {
        this.activeIndex = this.activeIndex + 6;
      }
    }

    for (let i = 0; i < this.creditAppService.CreditApplication.step; i++) {
      if (this.components[i]) {
        this.components[i].isActive = true;
      }
    }

    if (
      this.creditAppService.CreditApplication &&
      this.creditAppService.CreditApplication.buyer &&
      this.creditAppService.CreditApplication.buyer.personalInformation
        .currentAddress.yearsAtAddress > 1
    ) {
      // step is 2 then active index should be active index + 1
      if (this.creditAppService.CreditApplication.step === 2) {
        this.activeIndex = this.activeIndex + 1;
      }

      const componentToBeDisabled = {
        groupName: ComponentGroup.ResidenceInfo,
        component: new StepComponent(
          PreviousResidenceInfoComponent,
          ComponentName.PreviousResidenceInfoComponent,
          ComponentGroup.ResidenceInfo,
          false,
          StepType.Buyer
        ),
        componentName: ComponentName.PreviousResidenceInfoComponent,
      };
      this.notificationService.broadcastNotification({
        Message: 'Previous Residence is not required',
        Type: NotificationType.clearPreviousResidence,
        Payload: StepType.Buyer,
      });
      setTimeout(() => {
        this.disableComponentService.disableComponent(componentToBeDisabled);
      });
    }
    if (
      this.creditAppService.CreditApplication &&
      this.creditAppService.CreditApplication.coBuyer &&
      this.creditAppService.CreditApplication.coBuyer.personalInformation
        .currentAddress.yearsAtAddress > 1
    ) {
      // step is 8 then active index should be active index + 1
      if (this.creditAppService.CreditApplication.step === 8) {
        this.activeIndex = this.activeIndex + 1;
      }

      const componentToBeDisabled = {
        groupName: ComponentGroup.ResidenceInfo,
        component: new StepComponent(
          PreviousResidenceInfoComponent,
          ComponentName.CoBuyerPreviousResidenceInfoComponent,
          ComponentGroup.ResidenceInfo,
          false,
          StepType.CoBuyer
        ),
        componentName: ComponentName.CoBuyerPreviousResidenceInfoComponent,
      };
      this.notificationService.broadcastNotification({
        Message: 'Previous Residence is not required',
        Type: NotificationType.clearPreviousResidence,
        Payload: StepType.CoBuyer,
      });
      setTimeout(() => {
        this.disableComponentService.disableComponent(componentToBeDisabled);
      });
    }
    if (
      this.creditAppService.CreditApplication &&
      this.creditAppService.CreditApplication.buyer &&
      this.creditAppService.CreditApplication.buyer.financialInformation
        .currentEmployer.yearsAtEmployer > 1
    ) {
      // step is 4 then active index should be active index + 1
      if (this.creditAppService.CreditApplication.step === 4) {
        this.activeIndex = this.activeIndex + 1;
      }

      const componentToBeDisabled = {
        groupName: ComponentGroup.EmploymentInfo,
        component: new StepComponent(
          PreviousEmploymentInfoComponent,
          ComponentName.PreviousEmploymentInfoComponent,
          ComponentGroup.AdditionalInfo,
          false
        ),
        componentName: ComponentName.PreviousEmploymentInfoComponent,
      };
      setTimeout(() => {
        this.disableComponentService.disableComponent(componentToBeDisabled);
      });
    }
    if (
      this.creditAppService.CreditApplication &&
      this.creditAppService.CreditApplication.coBuyer &&
      this.creditAppService.CreditApplication.coBuyer.financialInformation
        .currentEmployer &&
      this.creditAppService.CreditApplication.coBuyer.financialInformation
        .currentEmployer.yearsAtEmployer > 1
    ) {
      // step is 10 then active index should be active index + 1
      if (this.creditAppService.CreditApplication.step === 10) {
        this.activeIndex = this.activeIndex + 1;
      }

      const componentToBeDisabled = {
        groupName: ComponentGroup.CoBuyerEmployment,
        component: new StepComponent(
          PreviousEmploymentInfoComponent,
          ComponentName.CoBuyerPreviousEmploymentInfoComponent,
          ComponentGroup.CoBuyerEmployment,
          true,
          StepType.CoBuyer
        ),
        componentName: ComponentName.CoBuyerPreviousEmploymentInfoComponent,
      };
      setTimeout(() => {
        this.disableComponentService.disableComponent(componentToBeDisabled);
      });
    }
    if (this.activeIndex >= 1 && this.isBuyNow) {
      try {
        /* istanbul ignore next */
        if ((window as any).buynow) {
          (window as any).buynow.navigation.hidePrev();
          (window as any).buynow.navigation.hideNext();
        }
      } catch (e) {
        /* istanbul ignore next */
        console.error(e);
      }
    }
    this.loadComponent(this.components[this.activeIndex]);
    console.log(`coBuyer:  ${this.creditAppService.CreditApplication.coBuyer}`);
    if (this.creditAppService.CreditApplication.hasCoBuyer) {
      this.notificationService.broadcastNotification({
        Message: 'Buyer has used Summoning Jutsu for Co-Buyer',
        Type: NotificationType.coBuyerActivation,
      });
    }
  }

  closeJacked() {
    this.stepnotSaved = false;
    if(this.isLeadRoutingFlag && this.isLegacyCreditApp){
      window.open(window.location.origin,"_self");
      const headerMain = document.getElementsByClassName('legacy-credit-next-cta') as HTMLCollectionOf<HTMLElement>;
      /* istanbul ignore next */
    if (headerMain.length > 0) {
      headerMain[0].style.visibility = 'visible';
    }
    }else{
      showCTA();
      const root = document.body.getElementsByClassName('main-body')[0];
      root?.classList?.remove('creditapp-body-jacked');
    }
  
  }

  deActivateCoBuyerFlow() {
    for (let i = 6; i <= 11; i++) {
      this.components[i].isActive = false;
    }
  }

  loadPreviousComponent(currentComponent: StepComponent): any {
    let currentComponentLoadedAtIndex = -1;
    if (currentComponent !== null) {
      currentComponentLoadedAtIndex = this.components.findIndex((cur) => {
        return (
          cur.componentName.toLowerCase() ===
          currentComponent.componentName.toLowerCase()
        );
      });
    }

    if (currentComponentLoadedAtIndex === -1) {
      return;
    } else {
      // Load previous component here
      let componentToBeLoaded: StepComponent;
      for (let i = currentComponentLoadedAtIndex - 1; i > -1; i--) {
        if (this.components[i].isActive === true) {
          componentToBeLoaded = this.components[i];
          break;
        }
      }

      if (
        componentToBeLoaded !== null &&
        typeof componentToBeLoaded !== 'undefined'
      ) {
        this.loadComponent(componentToBeLoaded);
      }
    }
  }

  unlocked(unlocked) {
    this.isUnlocked = unlocked;
    if (unlocked) {
      const self = this;
      setTimeout(() => {
        if (!self.isComponentHostInitialized) {
          this.initializeComponentHost();
          self.isComponentHostInitialized = true;
        }
      });
    }
  }

  disableComponent(component: StepComponent): any {
    const componentLoadedAtIndex = this.components.findIndex((cur) => {
      return (
        cur.componentName.toLowerCase() ===
        component.componentName.toLowerCase() && cur.type === component.type
      );
    });

    // load the component first and then disable this component here
    if (componentLoadedAtIndex === -1) {
      this.loadComponent(component);
      this.components[this.activeIndex].isActive = false;
    } else {
      this.components[componentLoadedAtIndex].isActive = false;
    }
  }

  loadComponent(component: StepComponent) {
    if (!component || !this.componentHost) {
      return;
    }
    const componentisAlreadyLoadedAtIndex = this.components.findIndex((cur) => {
      return (
        cur.componentName.toLowerCase() ===
        component.componentName.toLowerCase()
      );
    });
    if (componentisAlreadyLoadedAtIndex !== -1) {
      if (
        componentisAlreadyLoadedAtIndex === this.activeIndex &&
        this.components[this.activeIndex].componentRef !== null
      ) {
        // is the one currently loaded
        this.analyticsEventService.reportAnalyticsEvent(
          new ComponentLoaded(this.components[this.activeIndex])
        );
        return;
      }
      this.activeIndex = componentisAlreadyLoadedAtIndex;
      this.components[componentisAlreadyLoadedAtIndex].isActive = true;
    } else {
      this.components.push(Object.assign({}, component));
      this.activeIndex = this.components.length - 1;
    }
    const viewContainerRef = this.componentHost.viewContainerRef;
    viewContainerRef.detach();

    if (this.components[this.activeIndex].componentRef === null) {
      const componentFactory = this.componentFactoryResolver.resolveComponentFactory(
        this.components[this.activeIndex].component
      );
      this.components[
        this.activeIndex
      ].componentRef = viewContainerRef.createComponent(componentFactory);
      if (component.data) {
        this.components[this.activeIndex].componentRef.instance.data =
          component.data;
      }
      this.components[this.activeIndex].componentRef.instance.type =
        component.type;
    } else {
      if (component.data) {
        this.components[this.activeIndex].componentRef.instance.data =
          component.data;
      }
      viewContainerRef.insert(
        this.components[this.activeIndex].componentRef.hostView
      );
      this.components[this.activeIndex].componentRef.instance.type =
        component.type;
    }

    this.analyticsEventService.reportAnalyticsEvent(
      new ComponentLoaded(this.components[this.activeIndex])
    );

    scrollTo(0, 0);
    setTimeout(() => (window as any).scroll(0, 0), 100);    
  }

  SaveCreditApp() {
    this.creditAppService.SaveCreditAppAndForget(
      this.creditAppService.CreditApplication
    );
  }
}
